import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {QuestionType, RouterLinks} from '../../../constants';
import {Question} from '../../../models/underwriter.model';
import {FlowPlayerService} from '../../../services/flow-player.service';
import {GlobalQuestionService} from '../../../services/global-question.service';
import {QuestionFlowSessionQuery} from '../../state/question-flow-session.query';

declare var $: any;

@Component({
    selector: 'app-item-details',
    templateUrl: './item-details.component.html',
    styleUrls: ['./item-details.component.scss'],
    standalone: false
})
export class ItemDetailsComponent implements OnInit {

  question: Question;
  claim_details: any = {};
  questions: Question[];
  isSavingData: boolean = false;
  session_details: any;
  childrenQuestions: Question[] = [];
  loading = false;
  @Input() cart_item: any;
  QuestionType = QuestionType;
  constructor(private globalQuestionService: GlobalQuestionService,
    private sessionQuery: QuestionFlowSessionQuery,
    private router: Router,
    private flowPlayer: FlowPlayerService) { }

  ngOnInit(): void {
    this.session_details = this.sessionQuery.getValue();
    this.getFlowQuestions(this.cart_item?.flow_id, this.cart_item?.item_id, this.cart_item?.class_id);
  }

  getItemChildrenQuestions(question: Question): Question[] {
    let childQuestions = this.childrenQuestions.filter(x => x?.parent_control === question?.cent_aq_question_id);
    return this.childrenQuestions.filter(x => x?.parent_control === question?.cent_aq_question_id);
  }

  getDetails(){
    this.router.navigate([`${RouterLinks.ClaimSummaryItemEdit}`]);
  }

  getQuestionChildren(question: Question): Question[]{
    return this.childrenQuestions.filter(x => x?.parent_control === question?.cent_aq_question_id);
  }

  formatItemDescription(description: string, type: number): string {
    const splittedDescription = description?.split('|');
    if (splittedDescription) {
      switch (type) {
        case 1:
          return splittedDescription[0];
        case 2:
          return splittedDescription[1];
        default:
          return '';
      }
    }
    return '';
  }


  questionResponse(event): void {
    console.log('Saving...');
    if (event?.dependant_flow_id) {
      this.question = event;
      $('#modal-additional').modal('show');
    } else {
      const questionIndex = this.questions?.findIndex(question => question.cent_aq_question_id === event.cent_aq_question_id);
      if (questionIndex > -1) {
        if (this.questions[questionIndex]?.answer === event?.answer) {
          return;
        }
        this.questions[questionIndex] = event;
        this.globalQuestionService.saveIndividualAnswer(this.questions[questionIndex], this.questions[questionIndex].item_id)
          .subscribe(() => {
            if (!this.isSavingData) {
              this.isSavingData = true;
              this.globalQuestionService.setSummaryDataObservable(true);
            }
          });
      }
    }
  }

  getFlowQuestions(flow_id: any, item_id: any, class_id: any): any{
    this.flowPlayer.flowQuestions(flow_id, this.session_details?.category_id, this.session_details?.session_id, this.session_details?.group_id, item_id)
      .subscribe((questions: Question[]) => {
        if(!questions){
          return;
        }

        if(questions?.length){
          this.questions = [];
          this.childrenQuestions = [];
        }

        for (const q of questions) {
          if (q?.item_id?.toString() === item_id?.toString() && q?.product_class_id?.toString() === class_id?.toString()) {
            if (q?.parent_control) {
              this.childrenQuestions.push(q);
              const parentQuestion = questions.find(x => x?.cent_aq_question_id === q?.parent_control);
              if (parentQuestion && !this.questions?.some(x => x.cent_aq_question_id === parentQuestion?.cent_aq_question_id)) {
                this.questions.push(parentQuestion);
              }
            } else {
              if (!this.questions?.some(x => x?.cent_aq_question_id === q?.cent_aq_question_id)) {
                this.questions.push(q);
              }
            }
          }
        }
        console.log('Questions', this.questions);
        this.loading = false;
      })
  }


}
